import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const MODALBUTTONBLOCK_LEGACY_FIELD_ORDER = [
  "label",
  "action",
  "link_url",
  "style",
  "size"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  modalButtonBlockDescriptor: _generatedModalButtonBlockDescriptor,
  modalButtonBlockBlocDefinition,
  modalButtonBlockDashboardLayout,
  modalButtonBlockConfig,
  modalButtonBlockResolveConfig,
  modalButtonBlockProperties,
} = doodBlockConfig(
  {
    name: "Modal button",
    componentType: 'ModalButtonBlockComponent',
    category: 'content',
    description: "Modal button.",
    keywords: [],
    allowedIn: [
      { bloc: 'AuthenticationModalComponent', slot: 'signup_footer' },
      { bloc: 'UserFeedbackBlockComponent', slot: 'modal_positive_rating_content' },
      { bloc: 'UserFeedbackBlockComponent', slot: 'modal_negative_rating_content' },
      { bloc: 'GenericModalComponent', slot: 'content' },
      { bloc: 'OrderStatusPageComponent', slot: 'body' },
    ],
    sharedFields: {}
  },

  () => ({
    label: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.modal-button.label.label",
      },
    }),
    action: propertyValue({
      type: 'select',
      value: "GO_TO_URL",
      options: {
        label: "pages.blocks.modal-button.action.label",
        choices: [
          {
            value: "GO_TO_URL",
            label: "pages.blocks.modal-button.action.options.GO_TO_URL",
          },
          {
            value: "CLOSE_MODAL",
            label: "pages.blocks.modal-button.action.options.CLOSE_MODAL",
          },
        ],
      },
    }),
    link_url: propertyValue({
      type: 'link',
      value: '',
      options: {
        label: "pages.blocks.modal-button.link-url.label",
      },
    }),
    style: propertyValue({
      type: 'select',
      value: "primary",
      options: {
        label: "pages.blocks.modal-button.style.label",
        choices: [
          {
            value: "primary",
            label: "pages.blocks.modal-button.style.options.primary",
          },
          {
            value: "light",
            label: "pages.blocks.modal-button.style.options.light",
          },
          {
            value: "outlined",
            label: "pages.blocks.modal-button.style.options.outlined",
          },
          {
            value: "link",
            label: "pages.blocks.modal-button.style.options.link",
          },
        ],
      },
    }),
    size: propertyValue({
      type: 'select',
      value: "S",
      options: {
        label: "pages.blocks.modal-button.size.label",
        choices: [
          {
            value: "XXL",
            label: "pages.blocks.modal-button.size.options.XXL",
          },
          {
            value: "L",
            label: "pages.blocks.modal-button.size.options.L",
          },
          {
            value: "M",
            label: "pages.blocks.modal-button.size.options.M",
          },
          {
            value: "S",
            label: "pages.blocks.modal-button.size.options.S",
          },
          {
            value: "XS",
            label: "pages.blocks.modal-button.size.options.XS",
          },
        ],
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.modal-button.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.modal-button.fieldset.content.label",
            fields: [
              "label",
              "action",
              { prop: "link_url", visibleWhen: { action: "GO_TO_URL" } },
            ],
          },
          {
            legend: "pages.blocks.modal-button.fieldset.appearance.label",
            fields: ["style", "size"],
          },
        ],
      },
    ],
  })
);

export function modalButtonBlockDescriptor(): IBlockDescriptor;
export function modalButtonBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function modalButtonBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedModalButtonBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedModalButtonBlockDescriptor, modalButtonBlockProperties, fieldOrder);
}

export {
  modalButtonBlockBlocDefinition,
  modalButtonBlockDashboardLayout,
  modalButtonBlockProperties,
  modalButtonBlockConfig,
  modalButtonBlockResolveConfig,
};

export type ModalButtonBlockConfig = typeof modalButtonBlockConfig;
